import { Box } from '@chakra-ui/react';
import { SliceZone } from '@prismicio/react';
import React from 'react';
import ContentContainer from '../../components/ContentContainer';
import { topCapabilityComponents } from '../../components/Slices/TopCapabilities';

function PrismicTopCapabilitiesTemplate({ pageContext }) {
  const upperSlices = pageContext.slices.filter(
    (slice) =>
      slice.slice_type === 'seo' ||
      slice.slice_type === 'hero_slice' ||
      slice.slice_type === 'breadcrumbs' ||
      slice.slice_type === 'card_list_slice' ||
      slice.slice_type === 'footer_cta'
  );
  const lowerSlices = pageContext.slices.filter(
    (slice) =>
      slice.slice_type !== 'seo' &&
      slice.slice_type !== 'hero_slice' &&
      slice.slice_type !== 'breadcrumbs' &&
      slice.slice_type !== 'card_list_slice' &&
      slice.slice_type !== 'footer_cta' &&
      slice.id
  );

  return (
    <Box bg='linear-gradient(180deg, #F0F3F9 0%, rgba(240, 243, 249, 0) 40%)'>
      <ContentContainer noPadding>
        <SliceZone slices={upperSlices} components={topCapabilityComponents} />
        <Box
          pos='relative'
          pt={{ base: '68px', md: '151px' }}
          pb={{ base: '60px', md: '80px' }}
        >
          <Box
            clipPath={{
              base: 'polygon(0 5%, 100% 0, 100% 100%, 0% 100%)',
              md: 'polygon(0 9%, 100% 0, 100% 100%, 0% 100%)',
              lg: 'polygon(0 11%, 100% 0, 100% 100%, 0% 100%)',
            }}
            zIndex='-1'
            h='800px'
            pos='absolute'
            w='100vw'
            top='0'
            ml='-50vw'
            left='50%'
            bg='linear-gradient(180deg, #F1F3F5 -6.67%, #FFFFFF 75.18%)'
          />
          <SliceZone
            slices={lowerSlices}
            components={topCapabilityComponents}
          />
        </Box>
      </ContentContainer>
    </Box>
  );
}

export default PrismicTopCapabilitiesTemplate;
